import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import BreadcrumbBanner from './BreadcrumbBanner';

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_tj5fx8f',      // यहाँ अपनी Service ID डालें
      'template_3jcoa9x',     // यहाँ अपनी Template ID डालें
      form.current, 
      'TlS3ZvrYmOurPnebZ'       // यहाँ अपनी Public Key डालें
    )
    .then((result) => {
        alert("Message Sent Successfully! We will contact you soon.");
        form.current.reset(); // फॉर्म को रिसेट करने के लिए
    }, (error) => {
        alert("Failed to send, please try again.");
    });
  };

  return (
    <div>
      <BreadcrumbBanner title="Contact Us" />

      <section className="py-5">
        <div className="container">
          <div className="row">
            {/* Contact Details */}
            <div className="col-md-5 mb-5">
              <h2 className="fw-bold mb-4">Get In Touch</h2>
              <p className="text-muted mb-4">Need Office Chair Repair?</p>
              
              <div className="d-flex mb-4">
                <i className="fas fa-phone-alt fa-lg text-primary mt-1 me-3"></i>
                <div>
                  <h5 className="fw-bold">Contact No</h5>
                  <p>+91 97659 60907</p>
                </div>
              </div>

              <div className="d-flex mb-4">
                <i className="fas fa-envelope fa-lg text-primary mt-1 me-3"></i>
                <div>
                  <h5 className="fw-bold">E-Mail Us</h5>
                  <p>info@satishchairrepair.co.in</p>
                </div>
              </div>

              <div className="d-flex mb-4">
                <i className="fas fa-map-marker-alt fa-lg text-primary mt-1 me-3"></i>
                <div>
                  <h5 className="fw-bold">Address</h5>
                  <p>Patil estate lane no.3, Old Mumbai - Pune Hwy, Shivajinagar, Pune, Maharashtra 411005 India</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-md-7">
              <div className="card shadow-sm border-0 p-4">
                <form ref={form} onSubmit={sendEmail}>
                  <div className="mb-3">
                    <label className="form-label">Your Name</label>
                    <input type="text" name="user_name" className="form-control" placeholder="Enter Your Name" required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Contact No</label>
                    <input type="tel" name="user_phone" className="form-control" placeholder="+91 XXXXX XXXXX" required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Message</label>
                    <textarea name="message" className="form-control" rows="4" placeholder="Your Message" required></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary btn-lg w-100">Send Message</button>
                </form>
              </div>
            </div>
            <div className="col-md-12 mb-5">
  {/* ... पहले वाला कांटेक्ट डिटेल्स कोड ... */}
  
  {/* यहाँ मैप आ जाएगा */}
  <div className="mt-4">
    <div className="ratio ratio-16x9">
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.9094800428766!2d73.8508012759568!3d18.5329922687933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1cea5578291%3A0x41e30ea3fe055e80!2sSatish%20office%20chair%20repair%20and%20service!5e0!3m2!1sen!2sin!4v1783948897746!5m2!1sen!2sin" 
        style={{ border: 0, borderRadius: '10px' }} 
        allowFullScreen="" 
        loading="lazy"
        title="Location"
      ></iframe>
    </div>
  </div>
</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;